import React from 'react'
import { SearchInput, IdentityCard } from '../../../shared'
import { getFullName } from '../../../../misc/user.utilities'
import { LightUserBase } from '../../../../model/User'
import { UserSearchIdentityCardsBlockProps } from './UserSearchIdentityCardsBlock.model'

const minCharsBeforeSearchResults = 3

export function UserSearchIdentityCardsBlock<
  TSearchUser extends LightUserBase,
  TSelectedUser extends LightUserBase,
>({
  searchPlaceholder,
  searchTestId,
  searchInput,
  onSearchInputChange,
  searchResults,
  onSelectSearchResult,
  renderSearchResult,
  selectedUsers,
  onRemoveUser,
  disabled = false,
  emptyListMessage,
}: UserSearchIdentityCardsBlockProps<TSearchUser, TSelectedUser>) {
  return (
    <>
      {!disabled && (
        <SearchInput
          placeholder={searchPlaceholder}
          value={searchInput}
          onChange={onSearchInputChange}
          results={searchInput.length >= minCharsBeforeSearchResults ? searchResults : []}
          onSelect={onSelectSearchResult}
          renderResult={renderSearchResult}
          testId={searchTestId}
        />
      )}
      <div className="space-y-2 pr-2 overflow-y-scroll max-h-88">
        {selectedUsers.map((user) => (
          <IdentityCard
            key={user.id}
            title={getFullName(user)}
            icon="mail"
            subtitle={user.email}
            onRemove={() => onRemoveUser(user)}
            disabled={disabled}
          />
        ))}
        {selectedUsers.length === 0 && emptyListMessage != null && <div>{emptyListMessage}</div>}
      </div>
    </>
  )
}
